// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"328":"Widgets","772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"328":"ac119948","772":"ac119948"}[chunkId] + ".chunk.css";
};